import useUserData from "../../../hooks/user/useUserData";
import {useTranslation} from "react-i18next";
import {CALCULATIONS} from "../locales/namespaces";
import * as yup from "yup";
import {API} from "../../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../../helpers/errorHandling";
import {useFormik} from "formik";
import axios from "axios";
import {calculateInstallments} from "../helpers/calculations";
import moment from "moment";
import useUserAction from "../../../hooks/user/useUserAction";
import { showPopup } from '../../../../src/components/globalPopup/globalPopupService';
import { useLocation } from "react-router";
import { useRepaymentsContext } from "./RepaymentsContext";

const useRepaymentsForm = ({
							   id,
							   handleResults,
							   onClose,
							   calculationData,
							   contributions,
							   repayments,
							   updateRepayments,
							   handleUpdateRepayments,
							   RepaymentId,
							   repaymentsEdit
						   }) => {
	const {token, isLoggedIn} = useUserData()
	const {userLogout} = useUserAction()
	const {t} = useTranslation(CALCULATIONS)
	const location = useLocation()
	const { updateRepaymentsContext } = useRepaymentsContext();

	const mapRepayments = repayments.map(repayment => ({
		Amount: Number(repayment.Amount),
		NewRate: Number(repayment.NewRate),
		RepaymentNo: Number(repayment.RepaymentNo),
		Repayment_dt: moment(repayment.PaymentDt).format('MM/DD/YYYY'),
		id: repayment.id
	}))

	
	const validationSchema = yup.object({
		Amount: yup
		.number().required(t('Required'))
		.positive(t('Value must be a positive number.'))
		.min(0, t('Value must be a positive number.'))
		.max(99999999.99, t('Loan amount must be less than 100,000,000.'))
		.test('amount-validation', t('Repayment amount must not exceed the loan amount.'), function (value) {
			const { LoanAmount } = calculationData || {};
			const { RepaymentNo, id } = this.parent;

			if (!LoanAmount || value == null) return true;

			
			const repetitions = Number(RepaymentNo) || 0;
			const newTotal = value * (repetitions + 1);  

	
			const otherRepayments = repayments.filter(r => r.id !== id);
			const totalOtherAmounts = otherRepayments.reduce((sum, r) => sum + Number(r.Amount), 0);

			return totalOtherAmounts + newTotal <= LoanAmount;
		}),
		Repayment_dt: yup
		.date().typeError(t('Value must be a valid date.')).required(t('Required'))
		// .min(calculationData?.DateInstallment || moment(), t('Repayment date must not be before the first installment date.'))
		// .max(
		//     addYearsToDate(calculationData?.DateInstallment, Number(calculationData?.FloatingDuration) + Number(calculationData?.FixedDuration)),
		//     t('Repayment date must be within the total loan duration.')
		// ),
	})
	
	const onSubmit = (values) => {

		const newRate = calculationData.InterestType === 1 ? calculationData.FixedInterestRate : calculationData.InterestType === 2
			? calculationData.Spread + calculationData.Euribor :
			Number(moment(values.Repayment_dt).format('YYYY')) > Number(moment(calculationData.DateInstallment).format('YYYY')) + calculationData.FixedDuration
				? calculationData.Spread + calculationData.Euribor : calculationData.FixedInterestRate

		if (location.pathname === '/fast/calculation' ){
			console.log('values useRepaymentsForm');
			console.log(values);
			console.log('values useRepaymentsForm');
	
			let repeatedArray;

			if (values.id !== '') {
				repeatedArray = [{
					id: values.id,
					Amount: values.Amount,
					RepaymentNo: values.RepaymentNo,
					NewRate: newRate,
					PaymentDt: moment(values.Repayment_dt)
					.format("YYYY-MM-DD HH:mm:ss.SSS")
				}];
			} else {
				console.log('repayments.length useRepaymentsForm');
				console.log( repayments.length );
				console.log('repayments.length useRepaymentsForm');
				
				repeatedArray = Array.from({ length: values.RepaymentNo + 1 }, (_, index) => ({
					id: '90fast' + repayments.length + index,
					Amount: values.Amount,
					RepaymentNo: values.RepaymentNo + index + 1,
					NewRate: newRate,
					PaymentDt: moment(values.Repayment_dt)
					.add(index, 'years')
					.format("YYYY-MM-DD HH:mm:ss.SSS")
				}));
			}
			console.log('repeatedArray');
			console.log( repeatedArray );
			console.log('repeatedArray');
			
		
			updateRepaymentsContext(repeatedArray);

			handleUpdateRepayments(!updateRepayments)
			formik.resetForm()

			showPopup({
				title: '',
				message: !RepaymentId ? t('Repayment Stored Successfully!') : t('Repayment Updated Successfully!'),
				onConfirm: () => {
					
				}
			});

			// enqueueSnackbar(!RepaymentId ? t('Repayment Stored Successfully!') : t('Repayment Updated Successfully!'), {
			// 	variant: 'success'
			// })





			//When update repayment delete the previous value
			for (let i = 0; i <= mapRepayments.length - 1; i++) {
				if (mapRepayments[i].id === RepaymentId) {
					mapRepayments.splice(i, 1)
					break
				}
			}
			
			handleResults(calculateInstallments(
				0,
				calculationData.FixedDuration,
				calculationData.FloatingDuration,
				calculationData.FixedInterestRate,
				calculationData.Spread + calculationData.Euribor,
				contributions.find(f => f.id === calculationData.Contribution).Value,
				calculationData.LoanAmount,
				calculationData.isMonthly === 'isMonthly',
				calculationData.isHidePreviousInstallments === '1',
				moment(calculationData.DateInstallment).format('MM/DD/YYYY'),
				[...mapRepayments, {
					Amount: values.Amount,
					RepaymentNo: values.RepaymentNo,
					NewRate: values.NewRate,
					Repayment_dt: moment(values.Repayment_dt).format('MM/DD/YYYY')
				}],
				[],
				[],
				0,
				0,
				0,
				0,
				[...mapRepayments, {
					Amount: values.Amount,
					RepaymentNo: values.RepaymentNo,
					NewRate: newRate,
					Repayment_dt: moment(values.Repayment_dt).format('MM/DD/YYYY')
				}]
			));
			onClose()



			return
		}

		axios({
			method: 'post',
			data: {
				PaymentDt: values.Repayment_dt,
				Amount: values.Amount,
				RepaymentNo: values.RepaymentNo,
				NewRate: newRate,
				CalculationId: id,
				RepaymentId: RepaymentId
			},
			headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
			url: !RepaymentId ? `${API}/repayment/store` : `${API}/repayment/update`
		}).then(() => {
			handleUpdateRepayments(!updateRepayments)
			formik.resetForm()

			showPopup({
				title: '',
				message: !RepaymentId ? t('Repayment Stored Successfully!') : t('Repayment Updated Successfully!'),
				onConfirm: () => {
					
				}
			});

			// enqueueSnackbar(!RepaymentId ? t('Repayment Stored Successfully!') : t('Repayment Updated Successfully!'), {
			// 	variant: 'success'
			// })





			//When update repayment delete the previous value
			for (let i = 0; i <= mapRepayments.length - 1; i++) {
				if (mapRepayments[i].id === RepaymentId) {
					mapRepayments.splice(i, 1)
					break
				}
			}
			
			handleResults(calculateInstallments(
				0,
				calculationData.FixedDuration,
				calculationData.FloatingDuration,
				calculationData.FixedInterestRate,
				calculationData.Spread + calculationData.Euribor,
				contributions.find(f => f.id === calculationData.Contribution).Value,
				calculationData.LoanAmount,
				calculationData.isMonthly === 'isMonthly',
				calculationData.isHidePreviousInstallments === '1',
				moment(calculationData.DateInstallment).format('MM/DD/YYYY'),
				[...mapRepayments, {
					Amount: values.Amount,
					RepaymentNo: values.RepaymentNo,
					NewRate: values.NewRate,
					Repayment_dt: moment(values.Repayment_dt).format('MM/DD/YYYY')
				}],
				[],
				[],
				0,
				0,
				0,
				0,
				[...mapRepayments, {
					Amount: values.Amount,
					RepaymentNo: values.RepaymentNo,
					NewRate: newRate,
					Repayment_dt: moment(values.Repayment_dt).format('MM/DD/YYYY')
				}]
			));
			onClose()
		}).catch((error) => {
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to get repayment.')), {
					variant: 'error'
				}
			)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}
	
	const formik = useFormik({
		initialValues: {
			id:repaymentsEdit?.id || '',
			Amount: repaymentsEdit?.Amount || 0,
			RepaymentNo: repaymentsEdit?.RepaymentNo || 0,
			Repayment_dt: repaymentsEdit?.Repayment_dt ? moment(repaymentsEdit.Repayment_dt, "MMMM YYYY") : moment().startOf('day'),
			NewRate: repaymentsEdit?.NewRate ? repaymentsEdit?.NewRate : 5
		},
		validationSchema: validationSchema,
		onSubmit: onSubmit
	})
	
	return {
		formik,
		updateRepayments
	}
}

export default useRepaymentsForm
